<section
  class="client-list"
  [ngClass]="{'ascending-arrow': tableState.sortAscending, 'descending-arrow': !tableState.sortAscending}"
  data-dd-privacy="allow"
>
  <div [hidden]="clients().length === 0">
    <mat-table
      #table
      [@.disabled]="true"
      [dataSource]="clients()"
      matSort
      [matSortActive]="tableState.sortBy"
      matSortStart="asc"
      data-test="match-clients-table"
    >
      <ng-container matColumnDef="last_name">
        <mat-header-cell
          class="pad2 client-list-header name-cell"
          *matHeaderCellDef
          mat-sort-header
          disableClear="true"
          data-test="name-sort"
          aria-label="Name column"
          tabindex="0"
          [ngClass]="{'sorted-header': tableState.sortBy === 'last_name'}"
        >
          Name
        </mat-header-cell>
        <mat-cell
          class="pad2 client-list-detail name-cell"
          *matCellDef="let row"
          data-test="match-client-name"
          (click)="viewClient(row)"
          tabindex="0"
        >
          <div
            class="client-name"
          >
            <div
              [ngClass]="{ 'name-cell-mobile': breakPoint.isMobile }"
            >
            <span
              data-dd-privacy="mask"
              [attr.data-dd-action-name]="'client #' + row.patientId"
              [attr.data-test]="'client-name-' + row.displayName"
            >
              {{ row.displayName }}
            </span>
            </div>
          </div>
          <div class="client-status-flags">
            <sonder-tooltip
              *ngIf="row.urgent"
              class="client-status-indicator"
              desktopTooltipText="Urgent"
              tabindex="0"
            >
              <img
                alt="Urgent"
                displayText
                src="/assets/images/clients-list/urgent-tag.svg"
              />
            </sonder-tooltip>
            <sonder-tooltip
              *ngIf="row.clientUnderage"
              class="client-status-indicator"
              desktopTooltipText="Minor"
              tabindex="0"
              data-test="minor-tag"
            >
              <img
                alt="Minor"
                displayText
                src="/assets/images/clients-list/minor-tag.svg"
              />
            </sonder-tooltip>
            <ng-container
              *ngIf="!row.accountComplete"
            >
              <sonder-tooltip
                class="client-status-indicator"
                desktopTooltipText="Incomplete Account"
                data-test="incomplete-account-icon"
                tabindex="0"
              >
                <img
                  displayText
                  alt="Incomplete Account"
                  src="/assets/images/clients-list/incomplete-account-tag.svg"
                />
            </sonder-tooltip>
            </ng-container>
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="matched_at">
        <mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          class="pad3 client-list-header"
          disableClear="true"
          data-test="match-client-date-matched"
          aria-label="Date matched column"
          tabindex="0"
          [ngClass]="{
            'hide-column': breakPoint.isMobile,
            'sorted-header': tableState.sortBy === 'matched_at'
          }"
        >
          Date Matched
        </mat-header-cell>
        <mat-cell
          class="pad3 client-list-detail"
          *matCellDef="let row"
          (click)="viewClient(row)"
          data-test="match-client-status"
          tabindex="0"
          [ngClass]="{ 'hide-column': breakPoint.isMobile }"
        >
          <div class="table-column">
              <div class="table-cell-content">
              {{ row.matchedAt | localizedDate:{ month: 'short', day: 'numeric' } }}
            </div>
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="source">
        <mat-header-cell
          *matHeaderCellDef
          class="pad2 client-list-header"
          disableClear="true"
          data-test="match-client-source"
          aria-label="Source column"
          tabindex="0"
          [ngClass]="{ 'hide-column': breakPoint.isMobile }"
        >
          Source
        </mat-header-cell>
        <mat-cell
          class="pad2 client-list-detail"
          *matCellDef="let row"
          (click)="viewClient(row)"
          data-test="match-client-source"
          tabindex="0"
          [ngClass]="{ 'hide-column': breakPoint.isMobile  }"
        >
          <div class="table-column">
            <div class="table-cell-content">
             <span> {{ row.referralSource | referralSource:row.referralAasmState:row.memberAasmState }}</span>
            </div>
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="preference">
        <mat-header-cell
          *matHeaderCellDef
          class="pad2 client-list-header"
          disableClear="true"
          data-test="match-client-format-preference"
          aria-label="Format preference column"
          tabindex="0"
          [ngClass]="{ 'hide-column': breakPoint.isMobile || matchClientStore.status === 'client' }"
        >
          Format preference
        </mat-header-cell>
        <mat-cell
          class="pad2 client-list-detail"
          *matCellDef="let row"
          (click)="viewClient(row)"
          data-test="match-client-preference"
          tabindex="0"
          [ngClass]="{ 'hide-column': breakPoint.isMobile || matchClientStore.status === 'client' }"
        >
          <div class="table-column">
              <div class="table-cell-content">
              <span *ngIf="row.sessionPreference == 'noPreference' || row.sessionPreference == 'video'">Video</span>
              <span *ngIf="row.sessionPreference == 'noPreference'">,&nbsp;</span>
              <span *ngIf="row.sessionPreference == 'noPreference' || row.sessionPreference == 'inPerson'">In-office</span>
            </div>
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="topics">
        <mat-header-cell
          *matHeaderCellDef
          class="pad2 client-list-header"
          disableClear="true"
          data-test="match-client-therapy-topics"
          aria-label="Therapy topics column"
          tabindex="0"
          [ngClass]="{ 'hide-column': breakPoint.isMobile }"
        >
          Therapy topics
        </mat-header-cell>
        <mat-cell
          class="pad2 client-list-detail"
          *matCellDef="let row"
          (click)="viewClient(row)"
          data-test="match-client-therapy-topics"
          tabindex="0"
          [ngClass]="{ 'hide-column': breakPoint.isMobile }"
        >
          <div class="table-column">
              <div class="cell-detail-list">
              <ng-container *ngFor="let topic of row.therapyTopics; last as isLast">
                <span>{{topic}}{{!isLast ? ',&nbsp;' : ''}}</span></ng-container>
            </div>
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="requested_session">
        <mat-header-cell
          *matHeaderCellDef
          class="pad2 client-list-header"
          disableClear="true"
          data-test="match-client-requested-session"
          aria-label="Requested session column"
          tabindex="0"
          [ngClass]="{ 'hide-column': matchClientStore.status === 'client' }"
        >
          Requested session
        </mat-header-cell>
        <mat-cell
          class="pad2 client-list-detail"
          *matCellDef="let row"
          (click)="viewClient(row)"
          data-test="match-client-requested-session"
          tabindex="0"
          [ngClass]="{ 'hide-column': matchClientStore.status === 'client' }"
        >
          <div class="table-column">
            <div class="cell-detail-list">
              <ng-container>
                <ng-container *ngFor="let day of row.sessionRequestedDays; last as isLast">
                  <span>{{day}}{{!isLast ? ',&nbsp;' : ''}}</span>
                </ng-container>
              </ng-container>
              <span
                *ngIf="matchClientStore.status === clientStatus.ACCEPTED"
                (click)="goToCalendarSession($any($event), row.timeProposalId)"
                class="cell-link"
                >
                  {{row.timeProposalStartTime | formatRequestedTimeSlot:timezone}}
              </span>
              <span
                *ngIf="matchClientStore.status === clientStatus.NEW_MATCH">
                  {{row.timeProposalStartTime | formatRequestedTimeSlot:timezone}}
              </span>
            </div>
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="next_session_datetime">
        <mat-header-cell
          class="pad2 client-list-header hide-xs"
          *matHeaderCellDef
          mat-sort-header
          disableClear="true"
          data-test="name-sort"
          aria-label="Schedule column"
          tabindex="0"
          [ngClass]="{
            'hide-column': matchClientStore.status !== 'client',
            'show-column': matchClientStore.status === 'client',
            'sorted-header': tableState.sortBy === 'next_session_datetime'
          }"
        >
          Session
        </mat-header-cell>
        <mat-cell
          class="pad2 client-list-detail hide-xs"
          *matCellDef="let row"
          [routerLink]="['/scheduling', 'events', row.nextSessionId]"
          [ngClass]="{ 'hide-column': matchClientStore.status !== 'client', 'show-column': matchClientStore.status === 'client' }"
        >
          <div class="table-column">
            <div>
              {{ row.nextSessionDateTime | localizedDate:'weekday' }},
              {{ row.nextSessionDateTime | localizedDate:{ month: 'short', day: 'numeric' } }}
              <span *ngIf="!breakPoint.isMobile">,</span>
              <br *ngIf="breakPoint.isMobile">
              {{ row.nextSessionDateTime | localizedDate:'shortTime' | lowercase }} -
              {{ row.nextSessionEndTime | localizedDate:'shortTime' | lowercase }}
            </div>
          </div>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row
        *matRowDef="let row; columns: displayedColumns; let i = index;"
        class="client-list-row"
        [attr.data-test]="'match-client-list-row-' + i"
        tabindex="0"
        (click)="viewClient(row)"
        (keydown.enter)="viewClient(row)"
      >
      </mat-row>
    </mat-table>
  </div>
  @if (clients().length) {
    <mat-paginator
      #paginator
      [length]="paginationData?.filtered"
      [pageSize]="tableState.pageSize"
      [pageIndex]="tableState?.pageIndex"
      [pageSizeOptions]="[15, 30, 50]"
      (page)="onPaginate($event)"
      data-test="match-clients-pagination"
    >
    </mat-paginator>
  }
</section>

<div
  class="client-list-empty-state"
  *ngIf="clients().length === 0"
>
  <div class="loading-data" *ngIf="loadingData.length; else empty">
    <iris-icon name="info" [size]="irisIconSizes.MD" />
    {{ loadingData }}
  </div>
  <ng-template #empty>
    <div
      *ngIf="status === clientStatus.NEW_MATCH"
      class="client-list-empty-state-no-client-list"
      data-dd-privacy="allow"
    >
      <div *ngIf="showAvailabilityErrorState && (personaProviderProfile$ | async)?.acceptingClients === false; else noMatchesGeneral">
        <h2 class="iris-h2-responsive">Update your availability to get matches</h2>
      <div class="update-availability-button">
        <iris-button
          aria-label="Update availability"
          data-test="update-availability"
          [routerLink]="['/general_availability']"
        >
          Update availability
        </iris-button>
        </div>
      </div>
      <ng-template #noMatchesGeneral>
        <img src="/assets/images/clients-list/no-matches.svg" alt="">
        <h2>We're still finding you matches</h2>
      </ng-template>
    </div>
    <div *ngIf="status === clientStatus.ACCEPTED" class="client-list-empty-state-no-client-list">
      <h2 class="iris-h2-responsive">No recently accepted matches</h2>
      <div class="iris-body-responsive">If you're looking for a match that was made more than 30 days ago, change your settings to see matches older than 30 days.</div>
    </div>
      <div *ngIf="status === clientStatus.CLIENT">
      <h2 class="iris-h2-responsive">No scheduled matches</h2>
      <div class="iris-body-responsive">When a match schedules, you'll see them here.</div>
    </div>
  </ng-template>
</div>

